import { autoinject, Container } from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { TravelRequestsFilter } from 'model/filters/travel-requests-filter';
import { QueryMemory } from 'support/shared_models/query-memory';

@autoinject
export class TravelRequestsIndexScreen {
  router: Router;

  constructor(container: Container) {
    container.registerInstance(QueryMemory, new QueryMemory().initialize(TravelRequestsFilter));
  }

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      { route: '', redirect: 'list' },
      { route: 'list', moduleId: 'screens/travel_requests/requests-list', name: 'requests-list', title: 'Trips' },
      { route: ['new', ':id'], moduleId: 'screens/travel_requests/request-detail', name: 'request-detail', activationStrategy: 'replace' },
      { route: 'success', moduleId: 'screens/travel_requests/request-success', name: 'request-success', activationStrategy: 'replace' }
    ]);

    this.router = router;
  }
}
